<template>
  <div>
    <div class="mt-12 mb-4 d-flex">
      <h1 class="ang-heading">Formularz lead (v3)</h1>
    </div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <div
      v-if="sent"
      class="text-xs font-semibold py-5 px-5 uppercase rounded text-green-600 bg-green-200 uppercase last:mr-0 mr-1 mt-2"
    >
      Dziękujemy za poprawne uzupełnienie formularza
    </div>
    <div class="ang-card" v-show="!loading">
      <form
        v-if="!sent"
        id="ang3LeadForm"
        ref="ang3LeadForm"
        method="POST"
        class="ang-card-body"
        :action="action"
      >
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="first_name">Imię</label>
              <input
                type="text"
                class="ang-form-control"
                id="first_name"
                name="first_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="last_name">Nazwisko</label>
              <input
                type="text"
                class="ang-form-control"
                id="last_name"
                name="last_name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email">Adres e-mail</label>
              <input
                type="email"
                class="ang-form-control"
                id="email"
                name="email"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row form-group">
              <div class="col-12">
                <label class="ang-form-label" for="phone">Numer telefonu</label>
                <input type="text" class="ang-form-control dig" name="phone" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="flex flex-col">
                <label class="ang-form-label" for="phone"
                  >Partner leadowy</label
                >
                <select-field
                  name="lead_partner_uid"
                  placeholder="Wybierz"
                  v-model="partner"
                  :options="lead_partners"
                  required
                ></select-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div
                class="flex flex-col"
                v-if="
                  partner &&
                  lead_sources[partner] &&
                  lead_sources[partner].length > 0
                "
              >
                <label class="ang-form-label" for="phone">Źródło</label>
                <select-field
                  name="source_uid"
                  placeholder="Wybierz"
                  :options="{ values: lead_sources[partner] }"
                  required
                ></select-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="flex flex-col">
                <label class="ang-form-label" for="phone"
                  >Grupa produktowa</label
                >
                <select-field
                  name="product_group"
                  placeholder="Wybierz"
                  :options="{ values: product_groups }"
                ></select-field>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="flex flex-col">
                <label class="ang-form-label" for="phone">Expert</label>
                <select-field
                  name="user"
                  placeholder="Wybierz"
                  :options="{ values: users }"
                ></select-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="city">Miasto</label>
              <input
                type="text"
                class="ang-form-control"
                id="city"
                name="city"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="flex flex-col">
                <label class="ang-form-label" for="phone">Auth client ID</label>
                <select-field
                  name="cred"
                  placeholder="Wybierz"
                  v-model="cred"
                  :options="{ values: credentials }"
                ></select-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="ang-form-label" for="ref"
                >Komentarz/uwagi/notatki</label
              >
              <textarea
                class="rounded-lg pl-2 pt-2 focus:outline-none ang-form-control"
                rows="9"
                name="lead_comment"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row mt-3" v-if="consents">
          <div class="col-md-12 text-justify">
            <div class="form-group form-check">
              <input
                type="checkbox"
                class="form-check-input"
                :name="'consents[lead][check]'"
                value="1"
                :required="true"
              />
              <label class="form-check-label ang-consent"
                ><span class="mr-1">*</span
                ><span
                  >Oświadczam, że pozyskałam/em zgodę ww. klienta na
                  udostępnienie jego danych osobowych do ANG Odpowiedzialne
                  Finanse S.A. z siedzibą w Warszawie.</span
                ></label
              >
            </div>
            <!-- <div>
                Administratorem danych osobowych jest ANG Odpowiedzialne Finanse S.A. z siedzibą w
                Warszawie. Dane osobowe pośrednika są przetwarzane w celu
                weryfikacji prawidłowości i podstawy prawnej przekazania kontaktu
                do klienta oraz ustalenia, dochodzenia lub obrony roszczeń.
                Pośrednik ma w szczególności prawo dostępu do danych, ich
                sprostowania lub usunięcia. Szczegółowe informacje o przetwarzaniu
                danych i przysługujących prawach są dostępne w
                <a
                  href="https://angfinanse.pl/polityka-prywatnosci/"
                  target="_blank"
                  >Polityce prywatności.</a
                >
              </div> -->
          </div>
        </div>
        <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
          <h5 class="ang-card-title">Wystąpił błąd!</h5>
          <label class="form-error error">{{ error }}</label>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <spinner v-if="sending"></spinner>
            <button
              v-else
              data-label="Wyślij"
              type="submit"
              class="btn btn-lg ang-button ang-btn-lg spinn"
            >
              Wyślij
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
import spinner from "@/components/partials/misc/spinner";
import select from "@/components/partials/misc/select";
import api from "@/services/api";
import $ from "jquery";

export default {
  data() {
    return {
      consents: [],
      error: null,
      sending: false,
      token: null,
      sent: false,
      loading: false,
      cred: null,
      // biznes: false,
      step: this.base && this.base.length > 0 ? 2 : 1,
      partner: null,
      credentials: [
        { val: "SShfLV4lxoIhOCuRiYifeVLO6kE7PKMCr7zZ6jOp", text: "4" },
        { val: "foxo41oswZ0EzU3vKOfbimhWII9okqJHHFq31raF", text: "3" },
      ],
      users: [
        { val: "KCHAD3YEyE", text: "Wojtek" },
        { val: "Xo381N7V6R", text: "Piotrek" },
        { val: "2gUdCsXQCM", text: "Agata" },
      ],
      product_groups: [
        { val: "1", text: "Kredyty hipoteczne" },
        { val: "2", text: "Kredyty gotówkowe" },
        { val: "3", text: "Faktoring, leasing i inne" },
        { val: "4", text: "Ubezpieczenia majątkowe" },
        { val: "5", text: "Ubezpieczenia życiowe" },
        { val: "6", text: "Inwestycje" },
        { val: "7", text: "Fotowoltaika" },
        { val: "8", text: "Kredyty i pożyczki dla firm" },
        { val: "9", text: "Nieruchomości" },
      ],
      lead_sources: {
        "17bfb966-e04a-42fa-929c-942a877b3911": [
          { text: "nnv", val: "17bfb966-e04a-42fa-929c-942a877b3911" },
          { text: "www", val: "de5083d-106b-406c-bf30-c53712b9b829" },
          { text: "default", val: "c90b23eb-a57c-43a4-acc3-c405ca1e17d7" },
          { text: "formularz 1", val: "e2bd025b-a954-4a89-a02f-890cfe61005a" },
          { text: "inna strona", val: "f8d86469-3198-4f85-bea1-6f662cba9f26" },
        ],
        "c58def9a-a736-4261-a9aa-0710fb62fbcf": [
          { text: "jeden", val: "02a03503-c32f-45b3-a067-401a627436c2" },
          { text: "dwa", val: "be6a9c74-5f74-4e19-b628-b464a1353302" },
        ],
        "a138c42-2d37-45fe-9c6c-a94148708a03": [
          { text: "default PRO", val: "d56af1ce-e36d-4731-8271-9a9880f78696" },
        ],
        "75904504-2893-4841-b12d-0501aebdf141": [
          { text: "default", val: "9a5a004d-7118-49cb-98ab-28de8ec9b125" },
        ],
      },
      lead_partners: {
        values: [
          { text: "nnv", val: "17bfb966-e04a-42fa-929c-942a877b3911" },
          { text: "trinity", val: "c58def9a-a736-4261-a9aa-0710fb62fbcf" },
          { text: "profitowi", val: "75904504-2893-4841-b12d-0501aebdf141" },
          { text: "oirp", val: "a138c42-2d37-45fe-9c6c-a94148708a03}" },
        ],
      },
    };
  },
  components: {
    spinner,
    "select-field": select,
  },
  name: "angForm",
  computed: {
    action() {
      if (this.cred) {
        return "/api/lead";
      } else return "/client";
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      // self.scrollToAnchor("ang3LeadFormHeader");
      ajax.justValidate($(self.$refs.ang3LeadForm), () => {
        self.error = null;
        self.sending = true;
        if (self.cred) {
          let params = {
            grant_type: "client_credentials",
            client_id: self.credentials.find((el) => el.val === self.cred).text,
            client_secret: self.cred,
          };
          api.post("/oauth/token", params, (data) => {
            try {
              self.token = data.access_token;
              api.post(
                self.action,
                $(self.$refs.ang3LeadForm).serializeArray(),
                function (data) {
                  console.log(data);
                  self.sending = false;
                },
                null,
                null,
                self.token
              );
            } catch (e) {
              self.sending = false;
              alert(e);
              console.log(e);
            }
          });
        } else {
          api.post(
            self.action,
            $(self.$refs.ang3LeadForm).serializeArray(),
            function (data) {
              self.sending = false;
              console.log(data);
            }
          );
        }
      });
    });
  },

  methods: {
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
};
</script>
